module.exports = __webpack_public_path__ + "img/horcrux-harry-potter.19c820e2.png";